import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrokersListComponent } from './brokers-list/brokers-list.component';
import { ImportCsvFileComponent } from './import-csv-file/import-csv-file.component';
import { AuthGuard as AuthGuard } from './../services/auth.guard';
const routes: Routes = [
  { path: 'brokers-list', canActivate: [AuthGuard], component: BrokersListComponent },
  { path: 'import-csv-file', canActivate: [AuthGuard], component: ImportCsvFileComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CsvRoutingModule { }
